export interface ExemptionsRecord {
    id: number;
    departureAirport: string;
    arrivalAirport: string;
    validSince: Date;
    validUntil: Date;
}